import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Row,
  Col,
  Card,
  Button,
  Form,
  Dropdown,
  Modal,
  Tab,
  Nav
} from "react-bootstrap";
import CommonTable from '../components/CommonTable/CommonTable';
import '../tasks/tasklist.css';
import { 
  FiFile, 
  FiSearch,
  FiDownload,
  FiMoreVertical,
  FiRefreshCw,
  FiShare2,
  FiFolder,
  FiStar,
  FiX
} from 'react-icons/fi';
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileArchive,
  FaFileAlt,
  FaFolder
} from 'react-icons/fa';
import './documentDrive.css';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import BackToTop from '../components/BackToTop/BackToTop';
import { formatDateTimeToDDMMMYYYY } from '../../utils/dateFormatter';
import { buildDocumentSharePayload } from '../../utils/documentSharePayload';
import DocumentShareForm from './DocumentShareForm';
import ShareDocumentModal from './ShareDocumentModal';
import axiosInstance from '../../services/AxiosInstance';
import { getSavedViewMode, saveViewMode } from '../../utils/viewPersistence';
import { useDocumentAccess } from '../../hooks/useDocumentAccess';
import CategorizationIcon from './CategorizationIcon';
import Select from 'react-select';

const SharedDocuments = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasAccess, loading: accessLoading } = useDocumentAccess();
  
  const [sharedFiles, setSharedFiles] = useState([]);
  const [sharedByMeFiles, setSharedByMeFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSharedByMe, setLoadingSharedByMe] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermSharedByMe, setSearchTermSharedByMe] = useState('');
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [filteredSharedByMeFiles, setFilteredSharedByMeFiles] = useState([]);
  const [activeTab, setActiveTab] = useState('shared-with-me');
  // Share form state
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareSelectedItem, setShareSelectedItem] = useState(null);
  // Revoke confirmation modal state
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [revokeSelectedItem, setRevokeSelectedItem] = useState(null);
  const [shareSelectedBranches, setShareSelectedBranches] = useState([]);
  const [shareSelectedDepartments, setShareSelectedDepartments] = useState([]);
  const [shareSelectedSubDepartments, setShareSelectedSubDepartments] = useState([]);
  const [shareSelectedUsers, setShareSelectedUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [shareFilteredDepartments, setShareFilteredDepartments] = useState([]);
  const [shareFilteredSubDepartments, setShareFilteredSubDepartments] = useState([]);
  const [shareFilteredUsers, setShareFilteredUsers] = useState([]);
  const [shareAvailableUsers, setShareAvailableUsers] = useState([]);
  const [sharing, setSharing] = useState(false);
  const [viewMode, setViewMode] = useState(() => getSavedViewMode('sharedDocuments', 'table'));
  const [dropdownDirections, setDropdownDirections] = useState({});
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const mobileMenuRef = useRef(null);
  // Filter state
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [filterUserId, setFilterUserId] = useState(null);
  const [filterBranch, setFilterBranch] = useState(null);
  const [filterDepartment, setFilterDepartment] = useState(null);
  const [filterSubDepartment, setFilterSubDepartment] = useState(null);
  const [filteredDepartmentsForFilter, setFilteredDepartmentsForFilter] = useState([]);
  const [filteredSubDepartmentsForFilter, setFilteredSubDepartmentsForFilter] = useState([]);
  // Pending filter states (not applied until user clicks Apply Filters)
  const [pendingFilterUserId, setPendingFilterUserId] = useState(null);
  const [pendingFilterBranch, setPendingFilterBranch] = useState(null);
  const [pendingFilterDepartment, setPendingFilterDepartment] = useState(null);
  const [pendingFilterSubDepartment, setPendingFilterSubDepartment] = useState(null);
  const [filterUsers, setFilterUsers] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 50,
    hasMore: false
  });
  const [paginationSharedByMe, setPaginationSharedByMe] = useState({
    page: 1,
    limit: 50,
    hasMore: false
  });
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingMoreSharedByMe, setLoadingMoreSharedByMe] = useState(false);
  const filterRef = useRef(null);

  const notifySuccess = (msg) => toast.success(`✔️ ${msg}`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });

  const notifyError = (msg) => toast.error(`❌ ${msg}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

  // Helper function to determine dropdown direction based on row index
  const getDropdownDirectionByIndex = (rowIndex, totalRows) => {
    // If table has 3 or fewer items, all open down
    if (totalRows <= 3) {
      return 'down';
    }
    
    // First two items (index 0, 1) open down
    if (rowIndex < 2) {
      return 'down';
    }
    
    // For tables with 6 or more items, last 4 items open up
    // For tables with 4-5 items, last 3 items open up
    let itemsToOpenUp = 3;
    if (totalRows >= 6) {
      itemsToOpenUp = 4;
    }
    
    const lastItemsStart = totalRows - itemsToOpenUp;
    if (rowIndex >= lastItemsStart) {
      return 'up';
    }
    
    // All other items open down
    return 'down';
  };

  // Handle dropdown toggle to check position
  const handleDropdownToggle = (itemId, isOpen, event, rowIndex = null, totalRows = null) => {
    if (!isOpen) return; // Only handle when opening
    
    // Use setTimeout to ensure DOM is ready
    setTimeout(() => {
      try {
        // Find the currently open dropdown menu - check both container classes
        const visibleDropdowns = document.querySelectorAll('.user-list-card .dropdown-menu.show, .document-drive-container .dropdown-menu.show, .table-row .dropdown-menu.show');
        
        if (visibleDropdowns.length === 0) {
          return; // No open dropdown found
        }
        
        // Get the most recently opened dropdown (last one in the list)
        const dropdownMenu = visibleDropdowns[visibleDropdowns.length - 1];
        const dropdown = dropdownMenu.closest('.dropdown');
        
        if (!dropdown) {
          return;
        }
        
        // Determine direction based on row index if available (for table view)
        let direction = 'down';
        if (rowIndex !== null && totalRows !== null) {
          direction = getDropdownDirectionByIndex(rowIndex, totalRows);
        } else {
          // Fallback to viewport-based logic for non-table views
          const toggleElement = dropdown.querySelector('.dropdown-toggle');
          
          if (toggleElement) {
            const rect = toggleElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const spaceBelow = viewportHeight - rect.bottom;
            const spaceAbove = rect.top;
            
            // Estimate dropdown menu height
            let estimatedDropdownHeight = 180;
            if (dropdownMenu.offsetHeight > 0) {
              estimatedDropdownHeight = dropdownMenu.offsetHeight;
            } else {
              const itemCount = dropdownMenu.querySelectorAll('.dropdown-item').length;
              estimatedDropdownHeight = Math.max(itemCount * 45, 150);
            }
            
            const minSpaceBelow = estimatedDropdownHeight + 50;
            const minSpaceAbove = estimatedDropdownHeight + 20;
            
            const shouldOpenAbove = spaceBelow < minSpaceBelow && 
                                    spaceAbove > (spaceBelow + 80) && 
                                    spaceAbove >= minSpaceAbove;
            
            direction = shouldOpenAbove ? 'up' : 'down';
          }
        }
        
        setDropdownDirections(prev => ({
          ...prev,
          [itemId]: direction
        }));
        
        // Check if this is a table dropdown
        const isTableDropdown = dropdown.closest('.table-row') || dropdown.closest('.tasks-table') || dropdown.closest('table');
        
        // Force right alignment for table dropdowns (right edge of dropdown aligns with right edge of button)
        if (isTableDropdown) {
          dropdownMenu.style.right = '0';
          dropdownMenu.style.left = 'auto';
          dropdownMenu.style.transform = 'none';
        }
        
        // Apply Bootstrap's dropup class if needed
        // For table dropdowns, apply direction immediately
        if (isTableDropdown && rowIndex !== null && totalRows !== null) {
          const calculatedDirection = getDropdownDirectionByIndex(rowIndex, totalRows);
          if (calculatedDirection === 'up') {
            dropdown.classList.add('dropup');
            direction = 'up';
          } else {
            dropdown.classList.remove('dropup');
            direction = 'down';
          }
        }
        
        // Add class to card and column to allow dropdown overflow
        const driveItem = dropdown.closest('.drive-item');
        const driveItemCol = dropdown.closest('.drive-item-col');
        const tableRow = dropdown.closest('.table-row');
        if (driveItem) driveItem.classList.add('dropdown-open');
        if (driveItemCol) driveItemCol.classList.add('dropdown-open');
        if (tableRow) tableRow.classList.add('dropdown-open');
        
        if (direction === 'up') {
          dropdown.classList.add('dropup');
          // Check if menu gets cut off after Bootstrap positions it
          setTimeout(() => {
            const menuRect = dropdownMenu.getBoundingClientRect();
            if (menuRect.top < 0) {
              const toggleElement = dropdown.querySelector('.dropdown-toggle');
              if (toggleElement) {
                const rect = toggleElement.getBoundingClientRect();
                const spaceAbove = rect.top;
                dropdownMenu.style.maxHeight = `${Math.max(spaceAbove - 5, 120)}px`;
                dropdownMenu.style.overflowY = 'auto';
              }
            }
            // Re-apply right alignment after Popper.js positioning
            if (isTableDropdown) {
              dropdownMenu.style.right = '0';
              dropdownMenu.style.left = 'auto';
              dropdownMenu.style.transform = 'none';
            }
            // Ensure dropup class is still applied
            if (isTableDropdown && rowIndex !== null && totalRows !== null) {
              const calculatedDirection = getDropdownDirectionByIndex(rowIndex, totalRows);
              if (calculatedDirection === 'up') {
                dropdown.classList.add('dropup');
              }
            }
          }, 50);
        } else {
          dropdown.classList.remove('dropup');
          dropdownMenu.style.maxHeight = '';
          dropdownMenu.style.overflowY = '';
          // Re-apply right alignment after Popper.js positioning
          if (isTableDropdown) {
            setTimeout(() => {
              dropdownMenu.style.right = '0';
              dropdownMenu.style.left = 'auto';
              dropdownMenu.style.transform = 'none';
              // Ensure dropup class is removed if it should be down
              if (rowIndex !== null && totalRows !== null) {
                const calculatedDirection = getDropdownDirectionByIndex(rowIndex, totalRows);
                if (calculatedDirection === 'down') {
                  dropdown.classList.remove('dropup');
                }
              }
            }, 10);
          }
        }
        
        // Remove the class when dropdown closes
        const removeOverflowClass = () => {
          if (driveItem) driveItem.classList.remove('dropdown-open');
          if (driveItemCol) driveItemCol.classList.remove('dropdown-open');
          if (tableRow) tableRow.classList.remove('dropdown-open');
        };
        dropdown.addEventListener('hidden.bs.dropdown', removeOverflowClass, { once: true });
      } catch (error) {
        console.error('Error in handleDropdownToggle:', error);
        // Fallback to default 'down' direction
        setDropdownDirections(prev => ({
          ...prev,
          [itemId]: 'down'
        }));
      }
    }, 10); // Small delay to ensure DOM is updated
  };

  useEffect(() => {
    setPagination(prev => ({ ...prev, page: 1 }));
    setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
    loadSharedDocuments(1);
    loadSharedByMeDocuments(1);
    fetchBranches();
    fetchDepartments();
    fetchSubDepartments();
    fetchShareUsers();
    fetchFilterUsers();
  }, []);

  // Handle click outside filter panel
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Only handle if filter panel is actually shown
      if (!showFilterPanel || !filterRef.current) {
        return;
      }

      const target = event.target;
      
      // Check if click is on react-select menu or any react-select element
      // react-select renders menus in portals, so we need to check the target and its parents
      const isReactSelectElement = 
        target.closest('[class*="__control"], [class*="__menu"], [class*="__option"], [class*="__indicator"], [class*="__single-value"], [class*="__placeholder"], [class*="menu"], [id*="react-select"], [id*="react-select-"]') ||
        (target.className && typeof target.className === 'string' && (
          target.className.includes('__control') ||
          target.className.includes('__menu') ||
          target.className.includes('__option') ||
          target.className.includes('__indicator') ||
          target.className.includes('menu') ||
          target.className.includes('Menu') ||
          target.className.includes('react-select')
        )) ||
        target.closest('.react-select') ||
        target.closest('[class*="react-select"]');
      
      if (isReactSelectElement) {
        return; // Don't close if clicking on react-select element
      }
      
      // Check if the click is not on the filter button
      const filterButton = target.closest('button');
      if (filterButton && (filterButton.textContent.includes('Filters') || filterButton.querySelector('i.fa-filter'))) {
        return; // Don't close if clicking the filter button
      }
      
      // Check if click is on filter panel actions (Apply/Reset buttons)
      if (target.closest('.filter-actions') || target.closest('.search-btn') || target.closest('.reset-btn')) {
        return; // Don't close if clicking on filter action buttons
      }
      
      // Check if click is outside the filter panel
      if (filterRef.current && !filterRef.current.contains(target)) {
        setShowFilterPanel(false);
      }
    };

    if (showFilterPanel) {
      // Use a small delay to ensure the panel is fully rendered
      const timeoutId = setTimeout(() => {
        // Use click event instead of mousedown for better compatibility with react-select
        document.addEventListener('click', handleClickOutside, true);
      }, 10);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
  }, [showFilterPanel, activeTab]);

  // Initialize filter department/sub-department lists
  useEffect(() => {
    if (departments.length > 0) {
      setFilteredDepartmentsForFilter(departments);
    }
    if (subDepartments.length > 0) {
      setFilteredSubDepartmentsForFilter(subDepartments);
    }
  }, [departments, subDepartments]);

  // Initialize pending filter states when filter panel opens
  useEffect(() => {
    if (showFilterPanel) {
      // Sync pending states with current filter states when panel opens
      setPendingFilterUserId(filterUserId);
      setPendingFilterBranch(filterBranch);
      setPendingFilterDepartment(filterDepartment);
      setPendingFilterSubDepartment(filterSubDepartment);
      
      // Ensure filtered departments/sub-departments are set correctly based on current filters
      if (filterBranch && departments.length > 0) {
        const filtered = departments.filter(dept => dept.branch_id === filterBranch.value);
        setFilteredDepartmentsForFilter(filtered);
        
        if (filterDepartment && subDepartments.length > 0) {
          const subs = subDepartments.filter(sd => {
            const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
            return sdDeptId === filterDepartment.value;
          });
          setFilteredSubDepartmentsForFilter(subs);
        } else {
          const subs = subDepartments.filter(sd => {
            const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
            const dept = departments.find(d => d.id === sdDeptId);
            return dept && dept.branch_id === filterBranch.value;
          });
          setFilteredSubDepartmentsForFilter(subs);
        }
      } else {
        setFilteredDepartmentsForFilter(departments);
        setFilteredSubDepartmentsForFilter(subDepartments);
      }
    }
  }, [showFilterPanel, filterUserId, filterBranch, filterDepartment, filterSubDepartment, departments, subDepartments]);

  // Initialize share form filters when departments/sub-departments are loaded
  useEffect(() => {
    if (departments.length > 0) {
      setShareFilteredDepartments(departments);
    }
    if (subDepartments.length > 0) {
      setShareFilteredSubDepartments(subDepartments);
    }
  }, [departments, subDepartments]);

  // Fetch branches
  const fetchBranches = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      const res = await axiosInstance.get(`/settings/branches?corporate_id=${corporateId}`);
      const data = res.data;
      
      if (res) {
        setBranches(data.data || data || []);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  // Fetch departments
  const fetchDepartments = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
      const data = res.data;
      
      if (res) {
        const deptList = data.data || data || [];
        setDepartments(deptList);
        setShareFilteredDepartments(deptList);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  // Fetch sub-departments
  const fetchSubDepartments = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      let res;
      try {
        res = await axiosInstance.get(`/settings/subDepartments?corporate_id=${corporateId}`);
      } catch (e1) {
        res = await axiosInstance.get(`/settings/subdepartments?corporate_id=${corporateId}`);
      }
      const data = res.data;
      
      if (res) {
        const subDeptList = data.data || data || [];
        setSubDepartments(subDeptList);
        setShareFilteredSubDepartments(subDeptList);
      }
    } catch (error) {
      console.error('Error fetching sub-departments:', error);
    }
  };

  // Fetch users for share form
  const fetchShareUsers = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      if (!corporateId) return;
      
      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));
      
      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];

      const filteredUsers = users.filter(user => user.id !== userData.id);

      setShareAvailableUsers(filteredUsers);
      setShareFilteredUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Fetch users for filter
  const fetchFilterUsers = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      if (!corporateId) return;
      
      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));
      
      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];

      setFilterUsers(users);
    } catch (error) {
      console.error('Error fetching users for filter:', error);
    }
  };

  // Reload documents when switching tabs (to apply shared filters)
  useEffect(() => {
    if (activeTab === 'shared-with-me') {
      setPagination(prev => ({ ...prev, page: 1 }));
      loadSharedDocuments(1);
    } else if (activeTab === 'shared-by-me') {
      setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
      loadSharedByMeDocuments(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // Reload documents when filters change (shared between both tabs)
  useEffect(() => {
    // Reset to page 1 when filters change
    // Only reload if we're on the respective tab to avoid unnecessary API calls
    if (activeTab === 'shared-with-me') {
      setPagination(prev => ({ ...prev, page: 1 }));
      loadSharedDocuments(1);
    } else if (activeTab === 'shared-by-me') {
      setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
      loadSharedByMeDocuments(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterUserId, filterBranch, filterDepartment, filterSubDepartment]);

  // Reload documents when search terms change
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (activeTab === 'shared-with-me') {
        setPagination(prev => ({ ...prev, page: 1 }));
        loadSharedDocuments(1);
      } else if (activeTab === 'shared-by-me') {
        setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
        loadSharedByMeDocuments(1);
      }
    }, searchTerm || searchTermSharedByMe ? 500 : 0);
    
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, searchTermSharedByMe]);

  // Client-side filtering for search terms (immediate feedback)
  useEffect(() => {
    filterFiles();
  }, [searchTerm, sharedFiles]);

  useEffect(() => {
    filterSharedByMeFiles();
  }, [searchTermSharedByMe, sharedByMeFiles]);

  const formatDocumentItem = (item) => {
    if (!item) {
      return null;
    }

    if (item.document) {
      const formatted = formatDocumentItem(item.document);
      if (!formatted) {
        return null;
      }

      return {
        ...formatted,
        reason: item.reason || item.document_reason || formatted.reason,
        shared_by: item.shared_by || item.sharedBy || formatted.shared_by
      };
    }

    const normalizedType = item.type || item.item_type || (item.is_folder ? 'folder' : 'file');

    if (normalizedType === 'file') {
      const fileName = item.name || item.file_name || '';
      const fileExt = item.file_type?.toLowerCase() || fileName.split('.').pop()?.toLowerCase() || '';

      const fileTypeMap = {
        'pdf': 'pdf',
        'doc': 'word',
        'docx': 'word',
        'xls': 'excel',
        'xlsx': 'excel',
        'ppt': 'powerpoint',
        'pptx': 'powerpoint',
        'jpg': 'image',
        'jpeg': 'image',
        'png': 'image',
        'gif': 'image'
      };

      return {
        id: item.id,
        name: fileName,
        file_name: fileName,
        type: 'file',
        folder_id: item.document_path_id || item.folder_id,
        folder_name: item.folder?.name || item.folder_name || 'My Documents',
        size: item.file_size ? `${(parseFloat(item.file_size) / 1024 / 1024).toFixed(2)} MB` : item.size || '0 MB',
        last_accessed: item.last_accessed || item.updated_at || item.created_at,
        last_modified: item.last_modified || item.updated_at || item.created_at,
        file_type: fileTypeMap[fileExt] || item.file_type || 'file',
        category_id: item.category?.id || item.category_id || null,
        category_name: item.category?.name || item.category_name || null,
        is_private: item.is_private,
        version: item.version || null,
        reason: item.reason || item.description || null,
        shared_by: item.shared_by || item.sharedBy || item.shared_by_name || null,
        shared_at: item.shared_at || item.created_at || null,
        document_title: item.document_title || null,
        registered_to: item.registered_to || null,
        reference_number: item.reference_number || null,
        issue_date: item.issue_date || null,
        expiry_date: item.expiry_date || null,
        uploaded_by: item.uploaded_by || null,
        uploaded_by_name: item.uploaded_by?.full_name || null,
        uploaded_at: item.uploaded_at || item.created_at || null,
        updated_at: item.updated_at || null,
      };
    }

    if (normalizedType === 'folder') {
      return {
        id: item.id,
        name: item.name,
        type: 'folder',
        parent_id: item.parent_id,
        folder_name: item.parent?.name ? `${item.parent.name} / ${item.name}` : (item.folder_name || item.name),
        last_accessed: item.last_accessed || item.updated_at || item.created_at,
        last_modified: item.last_modified || item.updated_at || item.created_at,
        file_type: 'folder',
        shared_by: item.shared_by || item.sharedBy || item.shared_by_name || null,
        shared_at: item.shared_at || item.created_at || null
      };
    }

    return null;
  };

  const loadSharedDocuments = async (page = 1, append = false) => {
    // Prevent multiple simultaneous calls
    if (loading || loadingMore) return;
    
    if (page === 1) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }
    
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      // Build query parameters
      const params = new URLSearchParams();
      params.append('corporate_id', corporateId);
      
      // Add pagination parameters
      params.append('page', page);
      params.append('limit', pagination.limit);
      
      // Add filter parameters
      if (filterUserId) {
        params.append('user_id', filterUserId.value);
      }
      if (filterBranch) {
        params.append('branch_id', filterBranch.value);
      }
      if (filterDepartment) {
        params.append('department_id', filterDepartment.value);
      }
      if (filterSubDepartment) {
        params.append('sub_department_id', filterSubDepartment.value);
      }
      if (searchTerm.trim()) {
        params.append('search', searchTerm.trim());
      }
      
      const response = await axiosInstance.get(`/documents/internal/shared?${params.toString()}`);
      const data = response.data;
      
      if (response.status === 200 && data.success) {
        const responseData = data.data;
        const items = responseData.documents || responseData.items || responseData || [];
        
        // Store pagination information
        if (responseData.pagination) {
          setPagination(responseData.pagination);
        }
        
        // Format items to match expected structure
        const formattedItems = items
          .map(formatDocumentItem)
          .filter(Boolean);
        
        if (append) {
          // Append new documents when loading more pages
          setSharedFiles(prev => [...prev, ...formattedItems]);
        } else {
          // Replace with new documents when loading first page or filtering
          setSharedFiles(formattedItems);
        }
      } else if (response.status === 200) {
        // Handle case where API returns data directly without success wrapper
        const items = Array.isArray(data) ? data : (data.items || data.documents || []);
        const formattedItems = items
          .map(formatDocumentItem)
          .filter(Boolean);
        
        setSharedFiles(formattedItems);
      }
    } catch (error) {
      console.error('Error fetching shared documents:', error);
      notifyError(error.response?.data?.message || 'Failed to load shared documents');
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const loadSharedByMeDocuments = async (page = 1, append = false) => {
    // Prevent multiple simultaneous calls
    if (loadingSharedByMe || loadingMoreSharedByMe) return;
    
    if (page === 1) {
      setLoadingSharedByMe(true);
    } else {
      setLoadingMoreSharedByMe(true);
    }
    
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      // Build query parameters
      const params = new URLSearchParams();
      params.append('corporate_id', corporateId);
      
      // Add pagination parameters
      params.append('page', page);
      params.append('limit', paginationSharedByMe.limit);
      
      // Add filter parameters (shared filters between tabs)
      if (filterUserId) {
        params.append('user_id', filterUserId.value);
      }
      if (filterBranch) {
        params.append('branch_id', filterBranch.value);
      }
      if (filterDepartment) {
        params.append('department_id', filterDepartment.value);
      }
      if (filterSubDepartment) {
        params.append('sub_department_id', filterSubDepartment.value);
      }
      if (searchTermSharedByMe.trim()) {
        params.append('search', searchTermSharedByMe.trim());
      }
      
      const response = await axiosInstance.get(`/documents/shared-by-me?${params.toString()}`);
      const data = response.data;
      
      if (response.status === 200 && data.success) {
        const responseData = data.data;
        const documents = responseData.documents || [];
        
        // Store pagination information
        if (responseData.pagination) {
          setPaginationSharedByMe(responseData.pagination);
        }
        
        // Format items to match expected structure
        const formattedItems = documents
          .map((item) => {
            if (!item) return null;
            
            const fileName = item.file_name || '';
            const fileExt = item.file_type?.toLowerCase() || fileName.split('.').pop()?.toLowerCase() || '';
            
            const fileTypeMap = {
              'pdf': 'pdf',
              'doc': 'word',
              'docx': 'word',
              'xls': 'excel',
              'xlsx': 'excel',
              'ppt': 'powerpoint',
              'pptx': 'powerpoint',
              'jpg': 'image',
              'jpeg': 'image',
              'png': 'image',
              'gif': 'image'
            };
            
            return {
              id: item.id,
              name: fileName,
              file_name: fileName,
              type: 'file',
              size: item.file_size ? `${(parseFloat(item.file_size) / 1024 / 1024).toFixed(2)} MB` : '0 MB',
              last_modified: item.updated_at || item.created_at,
              file_type: fileTypeMap[fileExt] || item.file_type || 'file',
              category_id: item.category?.id || item.category_id || null,
              category_name: item.category?.name || null,
              is_private: item.is_private,
              version: item.version || null,
              document_title: item.document_title || null,
              registered_to: item.registered_to || null,
              reference_number: item.reference_number || null,
              issue_date: item.issue_date || null,
              expiry_date: item.expiry_date || null,
              uploaded_by: item.uploaded_by || null,
              uploaded_by_user: item.uploaded_by_user || null,
              uploaded_by_name: item.uploaded_by_user?.full_name || null,
              created_at: item.created_at || null,
              updated_at: item.updated_at || null,
              share_type: item.share_type || null,
              share_id: item.share_id || null,
              share_name: item.share_name || null,
              shared_with: item.shared_with || null
            };
          })
          .filter(Boolean);
        
        setSharedByMeFiles(formattedItems);
      } else if (response.status === 200) {
        // Handle case where API returns data directly without success wrapper
        const documents = data.data?.documents || data.documents || [];
        const formattedItems = documents
          .map((item) => {
            if (!item) return null;
            
            const fileName = item.file_name || '';
            const fileExt = item.file_type?.toLowerCase() || fileName.split('.').pop()?.toLowerCase() || '';
            
            const fileTypeMap = {
              'pdf': 'pdf',
              'doc': 'word',
              'docx': 'word',
              'xls': 'excel',
              'xlsx': 'excel',
              'ppt': 'powerpoint',
              'pptx': 'powerpoint',
              'jpg': 'image',
              'jpeg': 'image',
              'png': 'image',
              'gif': 'image'
            };
            
            return {
              id: item.id,
              name: fileName,
              file_name: fileName,
              type: 'file',
              size: item.file_size ? `${(parseFloat(item.file_size) / 1024 / 1024).toFixed(2)} MB` : '0 MB',
              last_modified: item.updated_at || item.created_at,
              file_type: fileTypeMap[fileExt] || item.file_type || 'file',
              category_id: item.category?.id || item.category_id || null,
              category_name: item.category?.name || null,
              is_private: item.is_private,
              version: item.version || null,
              document_title: item.document_title || null,
              registered_to: item.registered_to || null,
              reference_number: item.reference_number || null,
              issue_date: item.issue_date || null,
              expiry_date: item.expiry_date || null,
              uploaded_by: item.uploaded_by || null,
              uploaded_by_user: item.uploaded_by_user || null,
              uploaded_by_name: item.uploaded_by_user?.full_name || null,
              created_at: item.created_at || null,
              updated_at: item.updated_at || null,
              share_type: item.share_type || null,
              share_id: item.share_id || null,
              share_name: item.share_name || null,
              shared_with: item.shared_with || null
            };
          })
          .filter(Boolean);
        
        setSharedByMeFiles(formattedItems);
      }
    } catch (error) {
      console.error('Error fetching shared by me documents:', error);
      notifyError(error.response?.data?.message || 'Failed to load documents shared by you');
    } finally {
      setLoadingSharedByMe(false);
      setLoadingMoreSharedByMe(false);
    }
  };

  const filterFiles = () => {
    let filtered = [...sharedFiles];

    // Note: Backend filtering by user_id, branch, department, sub_department is handled by the API call with query parameters
    // Client-side filtering removed to avoid conflicts with backend filtering

    // Filter by branch (if document has branch info)
    if (filterBranch) {
      // Note: This assumes documents have branch information
      // Adjust based on your actual data structure
      filtered = filtered.filter(file => {
        // You may need to adjust this based on your data structure
        return true; // Placeholder - adjust based on actual data
      });
    }

    // Filter by department (if document has department info)
    if (filterDepartment) {
      // Note: This assumes documents have department information
      // Adjust based on your actual data structure
      filtered = filtered.filter(file => {
        // You may need to adjust this based on your data structure
        return true; // Placeholder - adjust based on actual data
      });
    }

    // Filter by sub-department (if document has sub-department info)
    if (filterSubDepartment) {
      // Note: This assumes documents have sub-department information
      // Adjust based on your actual data structure
      filtered = filtered.filter(file => {
        // You may need to adjust this based on your data structure
        return true; // Placeholder - adjust based on actual data
      });
    }

    // Filter by search term
    if (searchTerm.trim()) {
      filtered = filtered.filter(file =>
        file.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        file.folder_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        file.shared_by?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredFiles(filtered);
  };

  const filterSharedByMeFiles = () => {
    let filtered = [...sharedByMeFiles];

    // Note: Backend filtering by user_id, branch, department, sub_department is handled by the API call with query parameters
    // The user_id filter should filter documents shared TO that user (via shared_with field on backend)
    // Client-side filtering removed to avoid conflicts with backend filtering

    // Filter by branch (if document has branch info)
    if (filterBranch) {
      // Note: This assumes documents have branch information
      // Adjust based on your actual data structure
      filtered = filtered.filter(file => {
        // You may need to adjust this based on your data structure
        return true; // Placeholder - adjust based on actual data
      });
    }

    // Filter by department (if document has department info)
    if (filterDepartment) {
      // Note: This assumes documents have department information
      // Adjust based on your actual data structure
      filtered = filtered.filter(file => {
        // You may need to adjust this based on your data structure
        return true; // Placeholder - adjust based on actual data
      });
    }

    // Filter by sub-department (if document has sub-department info)
    if (filterSubDepartment) {
      // Note: This assumes documents have sub-department information
      // Adjust based on your actual data structure
      filtered = filtered.filter(file => {
        // You may need to adjust this based on your data structure
        return true; // Placeholder - adjust based on actual data
      });
    }

    // Filter by search term
    if (searchTermSharedByMe.trim()) {
      filtered = filtered.filter(file =>
        file.name?.toLowerCase().includes(searchTermSharedByMe.toLowerCase()) ||
        file.document_title?.toLowerCase().includes(searchTermSharedByMe.toLowerCase()) ||
        file.reference_number?.toLowerCase().includes(searchTermSharedByMe.toLowerCase()) ||
        file.share_name?.toLowerCase().includes(searchTermSharedByMe.toLowerCase())
      );
    }

    setFilteredSharedByMeFiles(filtered);
  };

  // Scroll-based pagination handler
  useEffect(() => {
    if (viewMode === 'table') {
      // For table view, use table wrapper scroll
      const handleTableScroll = (event) => {
        const threshold = 5;
        const wrapper = event.target;
        if (wrapper && wrapper.classList.contains('table-wrapper')) {
          const isNearBottom = wrapper.scrollHeight - wrapper.scrollTop <= wrapper.clientHeight + threshold;
          if (isNearBottom && !loadingMore && !loading && !loadingMoreSharedByMe && !loadingSharedByMe) {
            if (activeTab === 'shared-with-me' && pagination.hasMore) {
              const nextPage = pagination.page + 1;
              setPagination(prev => ({ ...prev, page: nextPage }));
              loadSharedDocuments(nextPage, true);
            } else if (activeTab === 'shared-by-me' && paginationSharedByMe.hasMore) {
              const nextPage = paginationSharedByMe.page + 1;
              setPaginationSharedByMe(prev => ({ ...prev, page: nextPage }));
              loadSharedByMeDocuments(nextPage, true);
            }
          }
        }
      };

      const wrapper = document.querySelector('.table-wrapper');
      if (wrapper) {
        wrapper.addEventListener('scroll', handleTableScroll);
        return () => {
          wrapper.removeEventListener('scroll', handleTableScroll);
        };
      }
      return () => {};
    } else {
      // For card view, use window scroll
      const handleWindowScroll = () => {
        const threshold = 5;
        const isNearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - threshold;
        if (isNearBottom && !loadingMore && !loading && !loadingMoreSharedByMe && !loadingSharedByMe) {
          if (activeTab === 'shared-with-me' && pagination.hasMore) {
            const nextPage = pagination.page + 1;
            setPagination(prev => ({ ...prev, page: nextPage }));
            loadSharedDocuments(nextPage, true);
          } else if (activeTab === 'shared-by-me' && paginationSharedByMe.hasMore) {
            const nextPage = paginationSharedByMe.page + 1;
            setPaginationSharedByMe(prev => ({ ...prev, page: nextPage }));
            loadSharedByMeDocuments(nextPage, true);
          }
        }
      };

      window.addEventListener('scroll', handleWindowScroll);
      return () => {
        window.removeEventListener('scroll', handleWindowScroll);
      };
    }
  }, [activeTab, pagination.hasMore, paginationSharedByMe.hasMore, loadingMore, loading, loadingMoreSharedByMe, loadingSharedByMe, viewMode, sharedFiles, sharedByMeFiles]);

  // Show loading while checking access
  if (accessLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Don't render if no access (will redirect)
  if (!hasAccess) {
    return null;
  }

  // Handle view mode change
  const handleViewModeChange = (mode) => {
    setViewMode(mode);
    saveViewMode('sharedDocuments', mode);
  };

  const getClassificationIcon = (classificationName) => {
    if (!classificationName) return null;
    
    const normalizedName = classificationName.toLowerCase().trim();
    
    // Map classification names to icon types
    const classificationMap = {
      'contracts': 'word',
      'contract': 'word',
      'legal': 'word',
      'reports': 'pdf',
      'report': 'pdf',
      'invoices': 'excel',
      'invoice': 'excel',
      'financial': 'excel',
      'finance': 'excel',
      'hr documents': 'word',
      'hr': 'word',
      'human resources': 'word',
      'project documents': 'word',
      'project': 'word',
      'general': 'file',
      'images': 'image',
      'image': 'image',
      'photos': 'image',
      'photo': 'image',
      'presentations': 'powerpoint',
      'presentation': 'powerpoint',
      'slides': 'powerpoint',
      'spreadsheets': 'excel',
      'spreadsheet': 'excel',
      'documents': 'word',
      'document': 'word',
      'archives': 'archive',
      'archive': 'archive',
      'zip': 'archive'
    };
    
    return classificationMap[normalizedName] || null;
  };

  const getFileIcon = (file) => {
    // Get file extension from file_name first (most reliable)
    let extension = '';
    if (file.file_name) {
      extension = file.file_name.split('.').pop()?.toLowerCase() || '';
    } else if (file.name) {
      extension = file.name.split('.').pop()?.toLowerCase() || '';
    }
    
    // If we have file_type, check if it's a MIME type or extension
    let fileType = file.file_type?.toLowerCase() || '';
    
    if (fileType) {
      // Check if it's a MIME type (contains '/')
      if (fileType.includes('/')) {
        // Extract extension from MIME type
        const mimeToExt = {
          'application/pdf': 'pdf',
          'application/msword': 'doc',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'application/vnd.ms-excel': 'xls',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'application/vnd.ms-powerpoint': 'ppt',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'text/plain': 'txt',
          'application/zip': 'zip',
          'application/x-rar-compressed': 'rar',
          'application/x-zip-compressed': 'zip'
        };
        extension = mimeToExt[fileType] || extension;
      } else {
        // It's already an extension
        if (fileType[0] === '.') {
          fileType = fileType.substring(1);
        }
        extension = fileType || extension;
      }
    }
    
    // Use extension if we have it, otherwise fallback
    const fileTypeKey = extension || fileType || '';
    
    const iconMap = {
      pdf: 'pdf',
      doc: 'word',
      docx: 'word',
      xls: 'excel',
      xlsx: 'excel',
      ppt: 'powerpoint',
      pptx: 'powerpoint',
      jpg: 'image',
      jpeg: 'image',
      png: 'image',
      gif: 'image',
      txt: 'text',
      zip: 'archive',
      rar: 'archive',
      folder: 'folder'
    };

    return iconMap[fileTypeKey] || 'file';
  };

  const getFileIconColor = (fileType) => {
    const colorMap = {
      pdf: '#d93025',
      word: '#2b579a',
      excel: '#1d6f42',
      powerpoint: '#d04423',
      image: '#34a853',
      text: '#6c757d',
      archive: '#ea4335',
      file: '#667eea'
    };
    return colorMap[fileType] || colorMap.file;
  };

  const getClassificationIconComponent = (classificationName, size = 20) => {
    if (!classificationName) {
      return <CategorizationIcon size={size} color="#FFB900" />;
    }
    
    const iconType = getClassificationIcon(classificationName);
    
    switch (iconType) {
      case 'pdf':
        return <FaFilePdf size={size} style={{ color: '#d93025' }} />;
      case 'word':
        return <FaFileWord size={size} style={{ color: '#2b579a' }} />;
      case 'excel':
        return <FaFileExcel size={size} style={{ color: '#1d6f42' }} />;
      case 'powerpoint':
        return <FaFilePowerpoint size={size} style={{ color: '#d04423' }} />;
      case 'image':
        return <FaFileImage size={size} style={{ color: '#34a853' }} />;
      case 'archive':
        return <FaFileArchive size={size} style={{ color: '#ea4335' }} />;
      case 'text':
        return <FaFileAlt size={size} style={{ color: '#6c757d' }} />;
      default:
        return <CategorizationIcon size={size} color="#FFB900" />;
    }
  };

  const getFileIconComponent = (file, size = 20) => {
    if (file.type === 'folder') {
      // For folders, try to use classification if available
      const classificationName = file.category_name || file.category?.name;
      return getClassificationIconComponent(classificationName, size);
    }

    const normalizedType = getFileIcon(file);
    
    switch (normalizedType) {
      case 'pdf':
        return <FaFilePdf size={size} />;
      case 'word':
        return <FaFileWord size={size} />;
      case 'excel':
        return <FaFileExcel size={size} />;
      case 'powerpoint':
        return <FaFilePowerpoint size={size} />;
      case 'image':
        return <FaFileImage size={size} />;
      case 'archive':
        return <FaFileArchive size={size} />;
      case 'text':
        return <FaFileAlt size={size} />;
      default:
        return <FiFile size={size} />;
    }
  };

  const handleViewDetails = (item) => {
    if (item.type === 'file' && item.id) {
      navigate(`/documents/details/${item.id}`, {
        state: { from: location.pathname }
      });
    }
  };

  const handleNavigateToFile = (item) => {
    if (item.type === 'folder') {
      if (item.id) {
        navigate(`/documents/folder/${item.id}`);
      } else {
        navigate('/documents');
      }
    } else {
      if (item.folder_id || item.document_path_id) {
        const folderId = item.folder_id || item.document_path_id;
        navigate(`/documents/folder/${folderId}`);
      } else {
        navigate('/documents');
      }
    }
    notifySuccess('Navigating to location...');
  };

  const handleDownload = async (file) => {
    if (!file || !file.id) {
      notifyError('Invalid file');
      return;
    }

    try {
      setLoading(true);
      
      const response = await axiosInstance.get(`/documents/${file.id}/download`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/octet-stream'
        }
      });

      if (response.status === 200) {
        let fileName = file.name || file.file_name || 'document';
        
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''));
          }
        }

        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        notifySuccess('File downloaded successfully');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
      
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorJson = JSON.parse(errorText);
          notifyError(errorJson.message || 'Failed to download file');
        } catch (parseError) {
          notifyError('Failed to download file');
        }
      } else {
        const errorMessage = error.response?.data?.message || 
                            error.response?.data?.error || 
                            'Failed to download file';
        notifyError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAddFavorite = async (file) => {
    if (!file || !file.id) {
      notifyError('Invalid file');
      return;
    }

    try {
      setLoading(true);
      
      const response = await axiosInstance.put(`/documents/${file.id}/favorite`);

      if (response.status === 200 || response.status === 204) {
        const isFavorited = response.data?.is_favorite ?? true;
        if (isFavorited) {
          notifySuccess('Document added to favorites');
        } else {
          notifySuccess('Document removed from favorites');
        }
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to toggle favorite';
      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Share form handlers
  const handleShareBranchChange = async (branchIds, selectedOptions) => {
    setShareSelectedBranches(branchIds);
    
    if (branchIds.length > 0) {
      const filtered = departments.filter(dept => branchIds.includes(dept.branch_id));
      setShareFilteredDepartments(filtered);
      
      const validDepartmentIds = shareSelectedDepartments.filter(deptId => {
        return filtered.some(d => d.id === deptId);
      });
      setShareSelectedDepartments(validDepartmentIds);
      
      let subs = [];
      if (validDepartmentIds.length > 0) {
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return validDepartmentIds.includes(sdDeptId);
        });
      } else {
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && branchIds.includes(dept.branch_id);
        });
      }
      setShareFilteredSubDepartments(subs);
      
      const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setShareSelectedSubDepartments(validSubDepartmentIds);
      
      await filterShareUsersBySelections(branchIds, validDepartmentIds, validSubDepartmentIds);
    } else {
      setShareFilteredDepartments(departments);
      
      if (shareSelectedDepartments.length > 0) {
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return shareSelectedDepartments.includes(sdDeptId);
        });
        setShareFilteredSubDepartments(subs);
        
        const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setShareSelectedSubDepartments(validSubDepartmentIds);
        
        await filterShareUsersBySelections([], shareSelectedDepartments, validSubDepartmentIds);
      } else {
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(shareAvailableUsers);
      }
    }
  };

  const handleShareDepartmentChange = async (departmentIds, selectedOptions) => {
    setShareSelectedDepartments(departmentIds);
    
    if (departmentIds.length > 0) {
      let subs = subDepartments.filter(sd => {
        const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
        return departmentIds.includes(sdDeptId);
      });
      
      if (shareSelectedBranches.length > 0) {
        subs = subs.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && shareSelectedBranches.includes(dept.branch_id);
        });
      }
      
      setShareFilteredSubDepartments(subs);
      
      const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setShareSelectedSubDepartments(validSubDepartmentIds);
      
      await filterShareUsersBySelections(shareSelectedBranches, departmentIds, validSubDepartmentIds);
    } else {
      if (shareSelectedBranches.length > 0) {
        const filtered = departments.filter(dept => shareSelectedBranches.includes(dept.branch_id));
        const filteredDeptIds = filtered.map(d => d.id);
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filteredDeptIds.includes(sdDeptId);
        });
        setShareFilteredSubDepartments(subs);
        
        const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setShareSelectedSubDepartments(validSubDepartmentIds);
        
        await filterShareUsersBySelections(shareSelectedBranches, [], validSubDepartmentIds);
      } else {
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(shareAvailableUsers);
        setShareSelectedSubDepartments([]);
      }
    }
  };

  const handleShareSubDepartmentChange = async (subDepartmentIds, selectedOptions) => {
    setShareSelectedSubDepartments(subDepartmentIds);
    await filterShareUsersBySelections(shareSelectedBranches, shareSelectedDepartments, subDepartmentIds);
  };

  const fetchShareUsersByFilters = async (branchIds, departmentIds, subDepartmentIds) => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      if (!corporateId) return [];
      
      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));
      
      if (branchIds && branchIds.length > 0) {
        params.append('branch', branchIds.join(','));
      }
      
      if (departmentIds && departmentIds.length > 0) {
        params.append('department', departmentIds.join(','));
      }
      
      if (subDepartmentIds && subDepartmentIds.length > 0) {
        params.append('sub_department', subDepartmentIds.join(','));
      }

      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];
      
      const filteredUsers = users.filter(user => user.id !== userData.id);
      
      return filteredUsers;
    } catch (error) {
      console.error('Error fetching users by filters:', error);
      return [];
    }
  };

  const filterShareUsersBySelections = async (branchIds, departmentIds, subDepartmentIds) => {
    if (branchIds.length > 0 || departmentIds.length > 0 || subDepartmentIds.length > 0) {
      const users = await fetchShareUsersByFilters(branchIds, departmentIds, subDepartmentIds);
      setShareFilteredUsers(users);
      
      if (shareSelectedUsers.length > 0) {
        const validUserIds = shareSelectedUsers.filter(userId => 
          users.some(user => {
            const userIdMatch = user.id === userId || user.CorporateUserId === userId;
            return userIdMatch;
          })
        );
        if (validUserIds.length !== shareSelectedUsers.length) {
          setShareSelectedUsers(validUserIds);
        }
      }
    } else {
      setShareFilteredUsers(shareAvailableUsers);
    }
  };

  const handleShareUserChange = (userIds, selectedOptions) => {
    setShareSelectedUsers(userIds);
  };

  // Handle share document (internal)
  const handleShareDocument = async () => {
    if (!shareSelectedItem || !shareSelectedItem.id) {
      notifyError('Invalid document');
      return;
    }

    try {
      setSharing(true);
      
      const payload = buildDocumentSharePayload(
        shareSelectedBranches,
        shareSelectedDepartments,
        shareSelectedSubDepartments,
        shareSelectedUsers
      );

      const response = await axiosInstance.put(`/documents/${shareSelectedItem.id}/share`, payload);

      if (response.status === 200) {
        notifySuccess('Document shared successfully');
        setShowShareModal(false);
        // Reset form
        setShareSelectedBranches([]);
        setShareSelectedDepartments([]);
        setShareSelectedSubDepartments([]);
        setShareSelectedUsers([]);
        setShareFilteredDepartments(departments);
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(shareAvailableUsers);
        setShareSelectedItem(null);
        // Refresh documents
        setPagination(prev => ({ ...prev, page: 1 }));
        setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
        await loadSharedDocuments(1);
        await loadSharedByMeDocuments(1);
      }
    } catch (error) {
      console.error('Error sharing document:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to share document';
      notifyError(errorMessage);
    } finally {
      setSharing(false);
    }
  };

  // Handle email share document
  const handleEmailShareDocument = async (payload) => {
    if (!shareSelectedItem || !shareSelectedItem.id) {
      notifyError('Invalid document');
      return;
    }

    try {
      setSharing(true);
      
      const requestPayload = {
        fileId: shareSelectedItem.id,
        email: payload.email,
        permission: 'read',
        expiryOption: payload.expiryOption || 'never'
      };

      const response = await axiosInstance.post('/api/internal/share', requestPayload);

      if (response.status === 200 || response.status === 201) {
        notifySuccess('Document shared via email successfully');
        setShowShareModal(false);
        setShareSelectedItem(null);
        // Refresh documents
        setPagination(prev => ({ ...prev, page: 1 }));
        setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
        await loadSharedDocuments(1);
        await loadSharedByMeDocuments(1);
      }
    } catch (error) {
      console.error('Error sharing document via email:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to share document via email';
      notifyError(errorMessage);
    } finally {
      setSharing(false);
    }
  };

  // Handle revoke share confirmation
  const handleRevokeShareClick = (item) => {
    if (!item || !item.id) {
      notifyError('Invalid document');
      return;
    }
    setRevokeSelectedItem(item);
    setShowRevokeModal(true);
  };

  // Handle revoke share (actual revocation)
  const handleRevokeShare = async () => {
    const item = revokeSelectedItem;
    if (!item || !item.id) {
      notifyError('Invalid document');
      setShowRevokeModal(false);
      setRevokeSelectedItem(null);
      return;
    }

    try {
      setLoadingSharedByMe(true);
      
      // Build payload based on shared_with type
      const payload = {
        branch_ids: [],
        department_ids: [],
        sub_department_ids: [],
        user_ids: []
      };

      // Determine which field to populate based on shared_with.type
      if (item.shared_with) {
        const sharedWith = item.shared_with;
        const shareId = sharedWith.id;
        
        if (sharedWith.type === 'branch') {
          payload.branch_ids = [shareId];
        } else if (sharedWith.type === 'department') {
          payload.department_ids = [shareId];
        } else if (sharedWith.type === 'subdepartment' || sharedWith.type === 'sub_department') {
          payload.sub_department_ids = [shareId];
        } else if (sharedWith.type === 'user') {
          payload.user_ids = [shareId];
        }
      } else if (item.share_type && item.share_id) {
        // Fallback to share_type and share_id if shared_with is not available
        const shareId = item.share_id;
        
        if (item.share_type === 'branch') {
          payload.branch_ids = [shareId];
        } else if (item.share_type === 'department') {
          payload.department_ids = [shareId];
        } else if (item.share_type === 'subdepartment' || item.share_type === 'sub_department') {
          payload.sub_department_ids = [shareId];
        } else if (item.share_type === 'user') {
          payload.user_ids = [shareId];
        }
      } else {
        notifyError('Unable to determine share information');
        setShowRevokeModal(false);
        setRevokeSelectedItem(null);
        return;
      }

      const response = await axiosInstance.delete(`/documents/${item.id}/share`, {
        data: payload
      });

      if (response.status === 200 || response.status === 204) {
        notifySuccess('Share revoked successfully');
        setShowRevokeModal(false);
        setRevokeSelectedItem(null);
        // Refresh documents
        setPaginationSharedByMe(prev => ({ ...prev, page: 1 }));
        await loadSharedByMeDocuments(1);
      }
    } catch (error) {
      console.error('Error revoking share:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to revoke share';
      notifyError(errorMessage);
    } finally {
      setLoadingSharedByMe(false);
    }
  };

  // Reset share form
  const resetShareForm = () => {
    setShareSelectedBranches([]);
    setShareSelectedDepartments([]);
    setShareSelectedSubDepartments([]);
    setShareSelectedUsers([]);
    setShareFilteredDepartments(departments);
    setShareFilteredSubDepartments(subDepartments);
    setShareFilteredUsers(shareAvailableUsers);
    setShareSelectedItem(null);
  };

  const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);
      
      if (diffInSeconds < 60) return 'just now';
      if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
      if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
      if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} days ago`;
      
      return formatDateTimeToDDMMMYYYY(dateString);
    } catch (error) {
      return dateString;
    }
  };


  // Handle filter branch change - filter departments
  const handleFilterBranchChange = (selectedOption) => {
    const branchId = selectedOption ? selectedOption.value : null;
    setPendingFilterBranch(selectedOption);
    
    if (branchId) {
      // Filter departments based on selected branch
      const filtered = departments.filter(dept => dept.branch_id === branchId);
      setFilteredDepartmentsForFilter(filtered);
      
      // Reset department and sub-department filters if they're no longer valid
      if (pendingFilterDepartment && !filtered.some(d => d.id === pendingFilterDepartment.value)) {
        setPendingFilterDepartment(null);
        setPendingFilterSubDepartment(null);
        setFilteredSubDepartmentsForFilter(subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        }));
      } else if (pendingFilterDepartment) {
        // Update sub-departments based on valid department
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return sdDeptId === pendingFilterDepartment.value;
        });
        setFilteredSubDepartmentsForFilter(subs);
      } else {
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        });
        setFilteredSubDepartmentsForFilter(subs);
      }
    } else {
      // Reset to all departments and sub-departments
      setFilteredDepartmentsForFilter(departments);
      setFilteredSubDepartmentsForFilter(subDepartments);
      setPendingFilterDepartment(null);
      setPendingFilterSubDepartment(null);
    }
  };

  // Handle filter department change - filter sub-departments
  const handleFilterDepartmentChange = (selectedOption) => {
    const departmentId = selectedOption ? selectedOption.value : null;
    setPendingFilterDepartment(selectedOption);
    
    if (departmentId) {
      // Filter sub-departments based on selected department
      let subs = subDepartments.filter(sd => {
        const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
        return sdDeptId === departmentId;
      });
      
      // If branch is also selected, ensure department belongs to branch
      if (pendingFilterBranch) {
        const dept = departments.find(d => d.id === departmentId);
        if (dept && dept.branch_id !== pendingFilterBranch.value) {
          subs = [];
        }
      }
      
      setFilteredSubDepartmentsForFilter(subs);
      setPendingFilterSubDepartment(null);
    } else {
      // Reset to all sub-departments based on branch (if any)
      if (pendingFilterBranch) {
        const filtered = departments.filter(dept => dept.branch_id === pendingFilterBranch.value);
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        });
        setFilteredSubDepartmentsForFilter(subs);
      } else {
        setFilteredSubDepartmentsForFilter(subDepartments);
      }
      setPendingFilterSubDepartment(null);
    }
  };

  // Handle filter sub-department change
  const handleFilterSubDepartmentChange = (selectedOption) => {
    setPendingFilterSubDepartment(selectedOption);
  };

  // Handle filter user change
  const handleFilterUserChange = (selectedOption) => {
    setPendingFilterUserId(selectedOption);
  };

  // Clear all filters
  const clearAllFilters = () => {
    setFilterUserId(null);
    setFilterBranch(null);
    setFilterDepartment(null);
    setFilterSubDepartment(null);
    setPendingFilterUserId(null);
    setPendingFilterBranch(null);
    setPendingFilterDepartment(null);
    setPendingFilterSubDepartment(null);
    setFilteredDepartmentsForFilter(departments);
    setFilteredSubDepartmentsForFilter(subDepartments);
  };

  const getSharedWithDisplay = (item) => {
    if (!item.shared_with && !item.share_name) return '—';
    
    if (item.shared_with) {
      const sharedWith = item.shared_with;
      if (sharedWith.type === 'user') {
        return sharedWith.full_name || sharedWith.name || 'User';
      } else if (sharedWith.type === 'branch') {
        return `Branch: ${sharedWith.name || 'N/A'}`;
      } else if (sharedWith.type === 'department') {
        return `Department: ${sharedWith.name || 'N/A'}`;
      } else if (sharedWith.type === 'subdepartment') {
        return `Sub-Department: ${sharedWith.name || 'N/A'}`;
      }
    }
    
    // Fallback to share_name if shared_with is not available
    if (item.share_name) {
      if (item.share_type === 'user') {
        return item.share_name;
      } else if (item.share_type === 'branch') {
        return `Branch: ${item.share_name}`;
      } else if (item.share_type === 'department') {
        return `Department: ${item.share_name}`;
      } else if (item.share_type === 'subdepartment') {
        return `Sub-Department: ${item.share_name}`;
      }
      return item.share_name;
    }
    
    return '—';
  };

  return (
    <>
      <ToastContainer />
      <Row>
        <Col lg={12}>
          <Card className="user-list-card">
            <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h5 className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '600', color: '#2c3e50' }}>
                Shared Files
              </h5>
            </Card.Header>

            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <Nav variant="tabs" className="nav-tabs" style={{ padding: '0 1.8rem', borderBottom: '1px solid #dee2e6', marginTop: '1rem', flexWrap: 'nowrap' }}>
                <Nav.Item style={{minWidth: '100px', textAlign: 'center'}}>
                  <Nav.Link eventKey="shared-with-me" style={{textAlign: 'center', fontWeight: '600'}}>Shared with Me</Nav.Link>
                </Nav.Item>
                <Nav.Item style={{minWidth: '100px', textAlign: 'center'}}>
                  <Nav.Link eventKey="shared-by-me" style={{textAlign: 'center', fontWeight: '600'}}>Shared by Me</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                {/* Shared with Me Tab */}
                <Tab.Pane eventKey="shared-with-me">
                  {/* Search and Filter Section */}
                  <div className="document-search-filter-section" style={{ padding: '1rem 0', position: 'relative' }}>
                    <div className="document-search-row" style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between', padding: '0 1.8rem' }}>
                      <div className="search-input-group" style={{ flex: 1 }}>
                        <FiSearch className="search-icon" />
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search shared files..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                {/* Mobile Menu Toggle Button */}
                <button
                  className="mobile-menu-toggle"
                  onClick={() => setShowMobileMenu(!showMobileMenu)}
                  aria-label="Toggle menu"
                >
                  <i className={`fas ${showMobileMenu ? 'fa-times' : 'fa-ellipsis-v'}`}></i>
                </button>
                {/* Desktop Controls - Hidden on Mobile */}
                <div className="desktop-controls" style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
                  <div className="shared-view-toggle-container">
                    <button
                      className={`shared-view-toggle-btn ${viewMode === 'tile' ? 'active' : ''}`}
                      onClick={() => handleViewModeChange('tile')}
                      title="Tile View"
                    >
                      <i className="fas fa-th-large"></i>
                    </button>
                    <button
                      className={`shared-view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                      onClick={() => handleViewModeChange('table')}
                      title="Table View"
                    >
                      <i className="fas fa-list"></i>
                    </button>
                  </div>
                  <button
                    className="btn"
                    onClick={() => setShowFilterPanel(!showFilterPanel)}
                    style={{
                      borderRadius: '8px',
                      padding: '0.5rem 1rem',
                      border: 'none',
                      color: '#C42126',
                      background: 'transparent',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.background = '#f8f9fa';
                      e.target.style.color = '#C42126';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.background = 'transparent';
                      e.target.style.color = '#C42126';
                    }}
                  >
                    <i className="fas fa-filter me-2"></i>
                    Filters
                  </button>
                </div>
              </div>

              {/* Mobile Collapsible Menu */}
              <div 
                ref={mobileMenuRef}
                className={`mobile-controls-menu ${showMobileMenu ? 'active' : ''}`}
              >
                <div className="mobile-controls-row">
                  {/* View Toggle */}
                  <div className="shared-view-toggle-container">
                    <button
                      className={`shared-view-toggle-btn ${viewMode === 'tile' ? 'active' : ''}`}
                      onClick={() => {
                        handleViewModeChange('tile');
                        setShowMobileMenu(false);
                      }}
                      title="Tile View"
                    >
                      <i className="fas fa-th-large"></i>
                    </button>
                    <button
                      className={`shared-view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                      onClick={() => {
                        handleViewModeChange('table');
                        setShowMobileMenu(false);
                      }}
                      title="Table View"
                    >
                      <i className="fas fa-list"></i>
                    </button>
                  </div>
                  
                  <button
                    className="btn"
                    onClick={() => {
                      setShowFilterPanel(!showFilterPanel);
                      setShowMobileMenu(false);
                    }}
                    style={{
                      borderRadius: '8px',
                      padding: '0.5rem 1rem',
                      border: 'none',
                      color: '#C42126',
                      background: 'white',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      flex: '1',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      minWidth: 0
                    }}
                  >
                    <i className="fas fa-filter"></i>
                    Filters
                  </button>
                </div>
              </div>
            </div>

            {/* Filter Panel */}
            {showFilterPanel && activeTab === 'shared-with-me' && (
              <div 
                className="filter-wrapper" 
                ref={filterRef}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="filter-form">
                      <div className="filter-row">
                        <div className="filter-group">
                          <label>User</label>
                          <Select
                            placeholder="Select User"
                            isClearable
                            value={pendingFilterUserId}
                            onChange={handleFilterUserChange}
                            options={filterUsers.map(user => ({
                              value: user.id || user.CorporateUserId,
                              label: user.full_name || user.name || user.email || `User ${user.id}`
                            }))}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>

                        <div className="filter-group">
                          <label>Branch</label>
                          <Select
                            placeholder="Select Branch"
                            isClearable
                            value={pendingFilterBranch}
                            onChange={handleFilterBranchChange}
                            options={branches.map(branch => ({
                              value: branch.id,
                              label: branch.name || branch.branch_name
                            }))}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>
                      </div>

                      <div className="filter-row">
                        <div className="filter-group">
                          <label>Department</label>
                          <Select
                            placeholder="Select Department"
                            isClearable
                            value={pendingFilterDepartment}
                            onChange={handleFilterDepartmentChange}
                            options={filteredDepartmentsForFilter.map(dept => ({
                              value: dept.id,
                              label: dept.name || dept.department_name
                            }))}
                            isDisabled={pendingFilterBranch === null ? false : filteredDepartmentsForFilter.length === 0}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>

                        <div className="filter-group">
                          <label>Sub-Department</label>
                          <Select
                            placeholder="Select Sub-Department"
                            isClearable
                            value={pendingFilterSubDepartment}
                            onChange={handleFilterSubDepartmentChange}
                            options={filteredSubDepartmentsForFilter.map(sd => ({
                              value: sd.id || sd.sub_department_id || sd.subDepartmentId,
                              label: sd.name || sd.sub_department_name || sd.subDepartmentName
                            }))}
                            isDisabled={pendingFilterDepartment === null ? false : filteredSubDepartmentsForFilter.length === 0}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>
                      </div>
                </div>

                <div className="filter-actions">
                  <button 
                    className="search-btn" 
                    onClick={() => {
                      // Apply pending filters to actual filter states
                      // The useEffect hook will automatically reload documents when filters change
                      setFilterUserId(pendingFilterUserId);
                      setFilterBranch(pendingFilterBranch);
                      setFilterDepartment(pendingFilterDepartment);
                      setFilterSubDepartment(pendingFilterSubDepartment);
                      setShowFilterPanel(false);
                    }}
                  >
                    <i className="fas fa-search"></i>
                    Apply Filters
                  </button>
                  <button 
                    className="reset-btn" 
                    onClick={() => {
                      clearAllFilters();
                      setShowFilterPanel(false);
                      // useEffect will automatically reload documents when filters change
                    }}
                  >
                    <i className="fas fa-undo"></i>
                    Reset
                  </button>
                </div>
              </div>
            )}

                  <Card.Body style={{ minHeight: '400px', overflow: 'visible' }}>
                    {loading && sharedFiles.length === 0 ? (
                <div className="d-flex justify-content-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading shared documents...</span>
                  </div>
                </div>
              ) : viewMode === 'tile' ? (
                <Row className="drive-grid">
                  {filteredFiles.length === 0 ? (
                    <Col xs={12} className="text-center py-5">
                      <FiFolder size={48} className="text-muted mb-3" />
                      <p className="text-muted">
                        {searchTerm 
                          ? 'No files match your search criteria' 
                          : 'No shared documents available'}
                      </p>
                    </Col>
                  ) : (
                    filteredFiles.map((item) => {
                      const fileIconType = getFileIcon(item);
                      const iconColor = getFileIconColor(fileIconType);
                      const isFolder = item.type === 'folder';
                      
                      return (
                        <Col key={item.id} xs={6} sm={4} md={3} lg={2} xl={2} className="drive-item-col">
                          <Card 
                            className={`drive-item ${isFolder ? 'folder-item' : 'file-item'}`}
                            onClick={(e) => {
                              const target = e.target;
                              if (target.closest('.drive-item-actions') || 
                                  target.closest('.dropdown') || 
                                  target.closest('.dropdown-toggle') ||
                                  target.closest('.dropdown-menu')) {
                                return;
                              }
                              if (item.type === 'file') {
                                handleViewDetails(item);
                              } else {
                                handleNavigateToFile(item);
                              }
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="drive-item-icon" style={{ color: iconColor }}>
                              {isFolder ? getFileIconComponent(item, 48) : getFileIconComponent(item, 48)}
                            </div>
                            <div className="drive-item-name" title={item.name}>
                              {item.name}
                            </div>
                            {item.category_name && (
                              <div className="text-muted small mt-1" style={{ fontSize: '0.75rem', color: '#667eea' }}>
                                {item.category_name}
                              </div>
                            )}
                            {item.shared_by && (
                              <div className="text-muted small mt-1" style={{ fontSize: '0.75rem' }}>
                                Shared by: {item.shared_by}
                              </div>
                            )}
                            <div className="drive-item-actions" onClick={(e) => e.stopPropagation()}>
                              <Dropdown 
                                onToggle={handleDropdownToggle}
                              >
                                <Dropdown.Toggle variant="link" className="drive-menu-toggle-docs" id={`dropdown-${item.id}`}>
                                  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                      <rect x="0" y="0" width="24" height="24"></rect>
                                      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                    </g>
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {item.type === 'file' && (
                                    <>
                                      <Dropdown.Item onClick={() => handleViewDetails(item)}>
                                        <FiFile className="me-2" />
                                        View Details
                                      </Dropdown.Item>
                                      <Dropdown.Item onClick={() => handleDownload(item)}>
                                        <FiDownload className="me-2" />
                                        Download
                                      </Dropdown.Item>
                                      
                                      
                                    </>
                                  )}
                                  {item.type === 'folder' && (
                                    <Dropdown.Item onClick={() => handleNavigateToFile(item)}>
                                      <FiFolder className="me-2" />
                                      Open Folder
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Card>
                        </Col>
                      );
                    })
                  )}
                </Row>
              ) : (
                <div className="row">
                  <CommonTable
                    columns={[
                      {
                        key: 'icon',
                        header: '',
                        render: (row) => {
                          const fileIconType = getFileIcon(row);
                          const iconColor = getFileIconColor(fileIconType);
                          return (
                            <div style={{ color: iconColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {getFileIconComponent(row, 20)}
                            </div>
                          );
                        },
                        cellClassName: 'width80',
                      },
                      {
                        key: 'name',
                        header: 'Title',
                        render: (row) => (
                          <div 
                            onClick={() => {
                              if (row.type === 'file') {
                                handleViewDetails(row);
                              } else {
                                handleNavigateToFile(row);
                              }
                            }}
                            style={{ cursor: 'pointer', color: '#333', fontWeight: '500' }}
                            className="text-truncate"
                            title={row.name}
                          >
                            {row.document_title || row.name}
                          </div>
                        ),
                      },
                      {
                        key: 'classification',
                        header: 'Classification',
                        render: (row) => (
                          <span className="text-muted">{row.category_name || 'N/A'}</span>
                        ),
                      },
                      {
                        key: 'reference',
                        header: 'Reference Number',
                        render: (row) => (
                          <span className="text-muted">{row.document_reference_number || row.reference_number || '—'}</span>
                        ),
                      },
                      {
                        key: 'uploaded',
                        header: 'Updated Date',
                        render: (row) => (
                          <span className="text-muted">
                            {row.updated_at ? formatTimeAgo(row.updated_at) : 'N/A'}
                          </span>
                        ),
                      },
                      {
                        key: 'uploadedBy',
                        header: 'Uploaded by',
                        render: (row) => (
                          <span className="text-muted">
                            {row.shared_by || row.uploaded_by_name || 'Unknown'}
                          </span>
                        ),
                      },
                      
                    ]}
                    data={filteredFiles}
                    actions={(row, rowIndex) => {
                      const actions = [];
                      
                      if (row.type === 'file') {
                        actions.push(
                          {
                            label: 'View Details',
                            icon: 'fas fa-file',
                            onClick: () => handleViewDetails(row),
                          },
                          {
                            label: 'Download',
                            icon: 'fas fa-download',
                            onClick: () => handleDownload(row),
                          },
                        );
                      } else if (row.type === 'folder') {
                        actions.push({
                          label: 'Open Folder',
                          icon: 'fas fa-folder-open',
                          onClick: () => handleNavigateToFile(row),
                        });
                      }
                      
                      return actions;
                    }}
                    emptyMessage={searchTerm 
                      ? 'No files match your search criteria' 
                      : 'No shared documents available'}
                    emptyStateIcon="fas fa-folder-open"
                    getRowId={(row, index) => row.id || index}
                    maxHeight="70vh"
                    minHeight="400px"
                  />
                </div>
                    )}
                  {/* Loading More Indicator for Shared With Me Tab */}
                  {loadingMore && (
                    <div className="d-flex justify-content-center align-items-center py-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading more documents...</span>
                      </div>
                    </div>
                  )}
                  </Card.Body>
                </Tab.Pane>

                {/* Shared by Me Tab */}
                <Tab.Pane eventKey="shared-by-me">
                  {/* Search and Filter Section */}
                  <div className="document-search-filter-section" style={{ padding: '1rem 0', position: 'relative' }}>
                    <div className="document-search-row" style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between', padding: '0 1.8rem' }}>
                      <div className="search-input-group" style={{ flex: 1 }}>
                        <FiSearch className="search-icon" />
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search documents shared by you..."
                          value={searchTermSharedByMe}
                          onChange={(e) => setSearchTermSharedByMe(e.target.value)}
                        />
                      </div>
                      {/* Mobile Menu Toggle Button */}
                      <button
                        className="mobile-menu-toggle"
                        onClick={() => setShowMobileMenu(!showMobileMenu)}
                        aria-label="Toggle menu"
                      >
                        <i className={`fas ${showMobileMenu ? 'fa-times' : 'fa-ellipsis-v'}`}></i>
                      </button>
                      {/* Desktop Controls - Hidden on Mobile */}
                      <div className="desktop-controls" style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
                        <div className="shared-view-toggle-container">
                          <button
                            className={`shared-view-toggle-btn ${viewMode === 'tile' ? 'active' : ''}`}
                            onClick={() => handleViewModeChange('tile')}
                            title="Tile View"
                          >
                            <i className="fas fa-th-large"></i>
                          </button>
                          <button
                            className={`shared-view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                            onClick={() => handleViewModeChange('table')}
                            title="Table View"
                          >
                            <i className="fas fa-list"></i>
                          </button>
                        </div>
                        <button
                          className="btn"
                          onClick={() => setShowFilterPanel(!showFilterPanel)}
                          style={{
                            borderRadius: '8px',
                            padding: '0.5rem 1rem',
                            border: 'none',
                            color: '#C42126',
                            background: 'transparent',
                            fontWeight: '600',
                            fontSize: '0.9rem',
                            transition: 'all 0.3s ease',
                            outline: 'none'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.background = '#f8f9fa';
                            e.target.style.color = '#C42126';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.background = 'transparent';
                            e.target.style.color = '#C42126';
                          }}
                        >
                          <i className="fas fa-filter me-2"></i>
                          Filters
                        </button>
                      </div>
                    </div>

                    {/* Mobile Collapsible Menu */}
                    <div 
                      ref={mobileMenuRef}
                      className={`mobile-controls-menu ${showMobileMenu ? 'active' : ''}`}
                    >
                      <div className="mobile-controls-row">
                        {/* View Toggle */}
                        <div className="shared-view-toggle-container">
                          <button
                            className={`shared-view-toggle-btn ${viewMode === 'tile' ? 'active' : ''}`}
                            onClick={() => {
                              handleViewModeChange('tile');
                              setShowMobileMenu(false);
                            }}
                            title="Tile View"
                          >
                            <i className="fas fa-th-large"></i>
                          </button>
                          <button
                            className={`shared-view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                            onClick={() => {
                              handleViewModeChange('table');
                              setShowMobileMenu(false);
                            }}
                            title="Table View"
                          >
                            <i className="fas fa-list"></i>
                          </button>
                        </div>
                        
                        <button
                          className="btn"
                          onClick={() => {
                            setShowFilterPanel(!showFilterPanel);
                            setShowMobileMenu(false);
                          }}
                          style={{
                            borderRadius: '8px',
                            padding: '0.5rem 1rem',
                            border: 'none',
                            color: '#C42126',
                            background: 'white',
                            fontWeight: '600',
                            fontSize: '0.9rem',
                            transition: 'all 0.3s ease',
                            outline: 'none',
                            flex: '1',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            minWidth: 0
                          }}
                        >
                          <i className="fas fa-filter"></i>
                          Filters
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Panel */}
                  {showFilterPanel && activeTab === 'shared-by-me' && (
                    <div 
                      className="filter-wrapper" 
                      ref={filterRef}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="filter-form">
                            <div className="filter-row">
                              <div className="filter-group">
                                <label>User</label>
                                <Select
                                  placeholder="Select User"
                                  isClearable
                                  value={pendingFilterUserId}
                                  onChange={handleFilterUserChange}
                                  options={filterUsers.map(user => ({
                                    value: user.id || user.CorporateUserId,
                                    label: user.full_name || user.name || user.email || `User ${user.id}`
                                  }))}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '38px',
                                      borderColor: '#e9ecef',
                                      '&:hover': {
                                        borderColor: '#ced4da'
                                      }
                                    })
                                  }}
                                />
                              </div>

                              <div className="filter-group">
                                <label>Branch</label>
                                <Select
                                  placeholder="Select Branch"
                                  isClearable
                                  value={pendingFilterBranch}
                                  onChange={handleFilterBranchChange}
                                  options={branches.map(branch => ({
                                    value: branch.id,
                                    label: branch.name || branch.branch_name
                                  }))}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '38px',
                                      borderColor: '#e9ecef',
                                      '&:hover': {
                                        borderColor: '#ced4da'
                                      }
                                    })
                                  }}
                                />
                              </div>
                            </div>

                            <div className="filter-row">
                              <div className="filter-group">
                                <label>Department</label>
                                <Select
                                  placeholder="Select Department"
                                  isClearable
                                  value={pendingFilterDepartment}
                                  onChange={handleFilterDepartmentChange}
                                  options={filteredDepartmentsForFilter.map(dept => ({
                                    value: dept.id,
                                    label: dept.name || dept.department_name
                                  }))}
                                  isDisabled={pendingFilterBranch === null ? false : filteredDepartmentsForFilter.length === 0}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '38px',
                                      borderColor: '#e9ecef',
                                      '&:hover': {
                                        borderColor: '#ced4da'
                                      }
                                    })
                                  }}
                                />
                              </div>

                              <div className="filter-group">
                                <label>Sub-Department</label>
                                <Select
                                  placeholder="Select Sub-Department"
                                  isClearable
                                  value={pendingFilterSubDepartment}
                                  onChange={handleFilterSubDepartmentChange}
                                  options={filteredSubDepartmentsForFilter.map(sd => ({
                                    value: sd.id || sd.sub_department_id || sd.subDepartmentId,
                                    label: sd.name || sd.sub_department_name || sd.subDepartmentName
                                  }))}
                                  isDisabled={pendingFilterDepartment === null ? false : filteredSubDepartmentsForFilter.length === 0}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '38px',
                                      borderColor: '#e9ecef',
                                      '&:hover': {
                                        borderColor: '#ced4da'
                                      }
                                    })
                                  }}
                                />
                              </div>
                            </div>
                      </div>

                      <div className="filter-actions">
                        <button 
                          className="search-btn" 
                          onClick={() => {
                            // Apply pending filters to actual filter states
                            // The useEffect hook will automatically reload documents when filters change
                            setFilterUserId(pendingFilterUserId);
                            setFilterBranch(pendingFilterBranch);
                            setFilterDepartment(pendingFilterDepartment);
                            setFilterSubDepartment(pendingFilterSubDepartment);
                            setShowFilterPanel(false);
                          }}
                        >
                          <i className="fas fa-search"></i>
                          Apply Filters
                        </button>
                        <button 
                          className="reset-btn" 
                          onClick={() => {
                            clearAllFilters();
                            setShowFilterPanel(false);
                            // useEffect will automatically reload documents when filters change
                          }}
                        >
                          <i className="fas fa-undo"></i>
                          Reset
                        </button>
                      </div>
                    </div>
                  )}

                  <Card.Body style={{ minHeight: '400px', overflow: 'visible' }}>
                    {loadingSharedByMe && sharedByMeFiles.length === 0 ? (
                      <div className="d-flex justify-content-center py-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading documents shared by you...</span>
                        </div>
                      </div>
                    ) : viewMode === 'tile' ? (
                      <Row className="drive-grid">
                        {filteredSharedByMeFiles.length === 0 ? (
                          <Col xs={12} className="text-center py-5">
                            <FiFolder size={48} className="text-muted mb-3" />
                            <p className="text-muted">
                              {searchTermSharedByMe 
                                ? 'No files match your search criteria' 
                                : 'No documents shared by you'}
                            </p>
                          </Col>
                        ) : (
                          filteredSharedByMeFiles.map((item) => {
                            const fileIconType = getFileIcon(item);
                            const iconColor = getFileIconColor(fileIconType);
                            
                            return (
                              <Col key={item.id} xs={6} sm={4} md={3} lg={2} xl={2} className="drive-item-col">
                                <Card 
                                  className="drive-item file-item"
                                  onClick={(e) => {
                                    const target = e.target;
                                    if (target.closest('.drive-item-actions') || 
                                        target.closest('.dropdown') || 
                                        target.closest('.dropdown-toggle') ||
                                        target.closest('.dropdown-menu')) {
                                      return;
                                    }
                                    handleViewDetails(item);
                                  }}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div className="drive-item-icon" style={{ color: iconColor }}>
                                    {getFileIconComponent(item, 48)}
                                  </div>
                                  <div className="drive-item-name" title={item.document_title || item.name}>
                                    {item.document_title || item.name}
                                  </div>
                                  {item.category_name && (
                                    <div className="text-muted small mt-1" style={{ fontSize: '0.75rem', color: '#667eea' }}>
                                      {item.category_name}
                                    </div>
                                  )}
                                  {item.share_name && (
                                    <div className="text-muted small mt-1" style={{ fontSize: '0.75rem' }}>
                                      Shared with: {getSharedWithDisplay(item)}
                                    </div>
                                  )}
                                  <div className="drive-item-actions" onClick={(e) => e.stopPropagation()}>
                                    <Dropdown 
                                      onToggle={handleDropdownToggle}
                                    >
                                      <Dropdown.Toggle variant="link" className="drive-menu-toggle-docs" id={`dropdown-shared-${item.id}`}>
                                        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
                                          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                          </g>
                                        </svg>
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleViewDetails(item)}>
                                          <FiFile className="me-2" />
                                          View Details
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDownload(item)}>
                                          <FiDownload className="me-2" />
                                          Download
                                        </Dropdown.Item>
                                        <Dropdown.Item 
                                          onClick={() => handleRevokeShareClick(item)}
                                          className="text-danger"
                                        >
                                          <FiX className="me-2" />
                                          Revoke Share
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </Card>
                              </Col>
                            );
                          })
                        )}
                      </Row>
                    ) : (
                      <div className="row">
                        <CommonTable
                          columns={[
                            {
                              key: 'icon',
                              header: '',
                              render: (row) => {
                                const fileIconType = getFileIcon(row);
                                const iconColor = getFileIconColor(fileIconType);
                                return (
                                  <div style={{ color: iconColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {getFileIconComponent(row, 20)}
                                  </div>
                                );
                              },
                              cellClassName: 'width80',
                            },
                            {
                              key: 'name',
                              header: 'Title',
                              render: (row) => (
                                <div 
                                  onClick={() => handleViewDetails(row)}
                                  style={{ cursor: 'pointer', color: '#333', fontWeight: '500' }}
                                  className="text-truncate"
                                  title={row.document_title || row.name}
                                >
                                  {row.document_title || row.name}
                                </div>
                              ),
                            },
                            {
                              key: 'classification',
                              header: 'Classification',
                              render: (row) => (
                                <span className="text-muted">{row.category_name || 'N/A'}</span>
                              ),
                            },
                            {
                              key: 'reference',
                              header: 'Reference Number',
                              render: (row) => (
                                <span className="text-muted">{row.reference_number || '—'}</span>
                              ),
                            },
                            {
                              key: 'sharedWith',
                              header: 'Shared With',
                              render: (row) => (
                                <span className="text-muted">{getSharedWithDisplay(row)}</span>
                              ),
                            },
                            {
                              key: 'uploaded',
                              header: 'Updated Date',
                              render: (row) => (
                                <span className="text-muted">
                                  {row.updated_at ? formatTimeAgo(row.updated_at) : 'N/A'}
                                </span>
                              ),
                            },
                            {
                              key: 'uploadedBy',
                              header: 'Uploaded by',
                              render: (row) => (
                                <span className="text-muted">
                                  {row.uploaded_by_name || row.uploaded_by_user?.full_name || 'You'}
                                </span>
                              ),
                            },
                          ]}
                          data={filteredSharedByMeFiles}
                          actions={(row, rowIndex) => {
                            const actions = [];
                            
                            actions.push(
                              {
                                label: 'View Details',
                                icon: 'fas fa-file',
                                onClick: () => handleViewDetails(row),
                              },
                              {
                                label: 'Download',
                                icon: 'fas fa-download',
                                onClick: () => handleDownload(row),
                              },
                              {
                                label: 'Revoke Share',
                                icon: 'fas fa-times',
                                onClick: () => handleRevokeShareClick(row),
                                className: 'text-danger'
                              }
                            );
                            
                            return actions;
                          }}
                          emptyMessage={searchTermSharedByMe 
                            ? 'No files match your search criteria' 
                            : 'No documents shared by you'}
                          emptyStateIcon="fas fa-folder-open"
                          getRowId={(row, index) => {
                            // Create unique ID by combining document ID with share information
                            // This ensures each row has a unique ID even if the same document appears multiple times
                            const docId = row.id || `doc-${index}`;
                            const shareId = row.share_id || row.shared_with?.id || `share-${index}`;
                            const shareType = row.share_type || row.shared_with?.type || 'unknown';
                            return `${docId}-${shareType}-${shareId}`;
                          }}
                          maxHeight="70vh"
                          minHeight="400px"
                        />
                      </div>
                    )}
                  {/* Loading More Indicator for Shared By Me Tab */}
                  {loadingMoreSharedByMe && (
                    <div className="d-flex justify-content-center align-items-center py-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading more documents...</span>
                      </div>
                    </div>
                  )}
                  </Card.Body>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Card>
        </Col>
      </Row>

      {/* Share Document Modal */}
      <ShareDocumentModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        fileId={shareSelectedItem?.id}
        selectedBranches={shareSelectedBranches}
        onBranchesChange={handleShareBranchChange}
        selectedDepartments={shareSelectedDepartments}
        onDepartmentsChange={handleShareDepartmentChange}
        selectedSubDepartments={shareSelectedSubDepartments}
        onSubDepartmentsChange={handleShareSubDepartmentChange}
        branches={branches}
        departments={departments}
        subDepartments={subDepartments}
        filteredDepartments={shareFilteredDepartments}
        filteredSubDepartments={shareFilteredSubDepartments}
        availableUsers={shareFilteredUsers}
        selectedUsers={shareSelectedUsers}
        onUsersChange={handleShareUserChange}
        onInternalShare={handleShareDocument}
        onEmailShare={handleEmailShareDocument}
        sharing={sharing}
        onReset={resetShareForm}
      />

      {/* Revoke Share Confirmation Modal */}
      <Modal show={showRevokeModal} onHide={() => {
        setShowRevokeModal(false);
        setRevokeSelectedItem(null);
      }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Revoke Share</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to revoke the share for this document?</p>
          {revokeSelectedItem && (
            <div className="mt-3">
              <p className="mb-1"><strong>Document:</strong> {revokeSelectedItem.document_title || revokeSelectedItem.name}</p>
              <p className="mb-0"><strong>Shared with:</strong> {getSharedWithDisplay(revokeSelectedItem)}</p>
            </div>
          )}
          <p className="mt-3 text-muted small">This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="doc-form-cancel-btn"
            onClick={() => {
              setShowRevokeModal(false);
              setRevokeSelectedItem(null);
            }}
            disabled={loadingSharedByMe}
          >
            Cancel
          </Button>
          <Button 
            className="doc-form-submit-btn"
            onClick={handleRevokeShare}
            disabled={loadingSharedByMe}
          >
            {loadingSharedByMe ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Revoking...
              </>
            ) : (
              'Revoke Share'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      
      <BackToTop />
      <InternalFooter />
      <style>{`
        .spinning {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default SharedDocuments;

